// src/evaluations/assessmentMode.js
// Modo del assessment (PLAN_UNIFICACION_ASSESSMENT.md):
//  - 'complete': solo postulantes con informe psicolaboral; incluye job fit /
//    Nine Box y considera DISC y razonamiento (comportamiento histórico).
//  - 'simple': cualquier postulante del proyecto, sin psicolaboral.
// Las evaluaciones y respuestas anteriores no traen `mode`: las creadas por el
// módulo Assessment 2 (`module: 'assessment2'`) son simples y el resto, completas.
export const ASSESSMENT_MODES = Object.freeze({
  COMPLETE: 'complete',
  SIMPLE: 'simple',
});

export const getAssessmentMode = (doc) => {
  if (doc?.mode === ASSESSMENT_MODES.SIMPLE || doc?.mode === ASSESSMENT_MODES.COMPLETE) return doc.mode;
  if (doc?.module === 'assessment2') return ASSESSMENT_MODES.SIMPLE;
  return ASSESSMENT_MODES.COMPLETE;
};

export const isSimpleAssessment = (doc) => getAssessmentMode(doc) === ASSESSMENT_MODES.SIMPLE;
